import { render, staticRenderFns } from "./IconTemplateSolid.vue?vue&type=template&id=353053a6"
import script from "./IconTemplateSolid.vue?vue&type=script&lang=js"
export * from "./IconTemplateSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports